const mockEnabledFromEnv = process.env.MOCK_ENABLED === 'true'

export default async (opts) => {
  // if (process.env.MOCK_INCLUDED !== 'true' && process.env.NODE_ENV === 'development') {
  //   console.log('Mock server was excluded. Any attempts to use it will be ignored')
  //   return
  // }

  if (localStorage.getItem('mock.enabled') === 'true' || sessionStorage.getItem('mock.enabled') === 'true') {
    console.log('enable mock by ' + (localStorage.getItem('mock.enabled') === 'true' ? 'local storage' : 'session storage'))
  } else if (mockEnabledFromEnv) {
    console.log('enable mock by environment variable')
  }

  /* if (mockEnabled) {
    if (!opts.backendBase) return
    await fetch(`${opts.backendBase}/mock/scenario`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        scenariosToAdd: []
      })
    })
  } */
}
